module.exports = __webpack_public_path__ + "static/img/jp_zhfx.80bca9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_zhfx.png
// module id = YKwU
// module chunks = 1